import {createStore, applyMiddleware, compose} from 'redux';
import {syncHistory} from 'react-router-redux'
import {install} from 'redux-loop';

export default function(reducer, initialState, {history}) {
  return createStore(reducer, initialState, compose(
    install(),
    applyMiddleware(syncHistory(history)),
    process.env.NODE_ENV === 'development'
      ? applyMiddleware(require('@jarvisaoieong/redux-logger')({collapsed: true}))
      : f => f,
  ));
}



/** WEBPACK FOOTER **
 ** ./src/app/helpers/createStore.js
 **/